import { InjectionToken, Provider } from '@angular/core';

import { BrockmeyerCampaignDeleteAsyncJob } from './brockmeyer/campaign-delete';
import { BulkContainersDeleteAsyncJob } from './containers/delete';
import { BulkReferralApplicationsAcceptAsyncJob } from './referrals/applications-accept';
import { BulkReferralApplicationsOpenAsyncJob } from './referrals/applications-open';
import { BulkReferralApplicationsRejectAsyncJob } from './referrals/applications-reject';

export const ASYNC_JOB_CONFIG_TOKEN = new InjectionToken('ASYNC_JOB_CONFIG_TOKEN');
export const ASYNC_JOB_CONFIG_PROVIDER: Provider[] = [
  { provide: ASYNC_JOB_CONFIG_TOKEN, useClass: BrockmeyerCampaignDeleteAsyncJob, multi: true },

  { provide: ASYNC_JOB_CONFIG_TOKEN, useClass: BulkReferralApplicationsOpenAsyncJob, multi: true },
  {
    provide: ASYNC_JOB_CONFIG_TOKEN,
    useClass: BulkReferralApplicationsAcceptAsyncJob,
    multi: true,
  },
  {
    provide: ASYNC_JOB_CONFIG_TOKEN,
    useClass: BulkReferralApplicationsRejectAsyncJob,
    multi: true,
  },

  { provide: ASYNC_JOB_CONFIG_TOKEN, useClass: BulkContainersDeleteAsyncJob, multi: true },
];
